import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MerchantDashboard from "@/pages/merchant/MerchantDashboard";
import NewApplication from "@/pages/merchant/NewApplication";
import ApplicationDetail from "@/pages/merchant/ApplicationDetail";
import MunicipalityDashboard from "@/pages/municipality/MunicipalityDashboard";
import Regulations from "@/pages/municipality/Regulations";
import ManufacturerDashboard from "@/pages/manufacturer/ManufacturerDashboard";
import AgentScanner from "@/pages/agent/AgentScanner";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PaymentSuccess from "@/pages/merchant/PaymentSuccess";

function RoleHome() {
  const { user } = useAuth();
  switch (user.role) {
    case "COMMERCANT": return <MerchantDashboard />;
    case "ADMIN_MAIRIE":
    case "AGENT_MAIRIE": return <MunicipalityDashboard />;
    case "FABRICANT": return <ManufacturerDashboard />;
    case "AGENT_CONTROLE": return <AgentScanner />;
    case "SUPER_ADMIN": return <AdminDashboard />;
    default: return <div className="p-8">Rôle non reconnu.</div>;
  }
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500">Chargement...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Shell>{children}</Shell>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/app" element={<Protected><RoleHome /></Protected>} />
            <Route path="/app/nouvelle-demande" element={<Protected><NewApplication /></Protected>} />
            <Route path="/app/dossier/:id" element={<Protected><ApplicationDetail /></Protected>} />
            <Route path="/app/reglements" element={<Protected><Regulations /></Protected>} />
            <Route path="/app/paiement/succes" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
